/* globals Vue */
import { Tabs } from "buefy";
Vue.use(Tabs);
// Componentes específicos de Mex
import MexIndex from "./MexIndex.vue";

const mexApp = new Vue({
  el: "#mex-app",
  components: {
    MexIndex,
  },
});

window.mexApp = mexApp;